import { cx } from '@emotion/css';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, ListItemIcon as MUIListItemIcon, Menu as MUIMenu, MenuItem as MUIMenuItem } from '@mui/material';
import React, { useCallback, useMemo, useState } from 'react';
import { ix } from '../../../utils/ix';
import { Typography } from '../../electrons';
import { useStyles } from './Menu.styles';
export function Menu(props) {
    const { onButtonClick, onClose } = props;
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const menuId = ix(props.id, 'menu');
    const horizontalPopoverOffset = useMemo(() => {
        switch (props.horizontalPosition) {
            case 'right':
                return 'left';
            case 'left':
                return 'right';
            default:
                return 'right';
        }
    }, [props.horizontalPosition]);
    const handleButtonClick = useCallback((event) => {
        setAnchorEl(event.currentTarget);
        if (onButtonClick) {
            onButtonClick(event);
        }
    }, [onButtonClick]);
    const handleClose = useCallback((event, reason) => {
        setAnchorEl(null);
        if (onClose) {
            onClose(event, reason);
        }
    }, [onClose]);
    const handleItemClick = (menuItem) => (event) => {
        if (menuItem.onClick) {
            menuItem.onClick(event);
        }
        handleClose(event, 'itemClick');
    };
    const getMenuItemId = useCallback((menuItem) => {
        if (menuItem.id) {
            return menuItem.id;
        }
        else if (typeof menuItem.label === 'string') {
            return menuItem.label;
        }
        return '';
    }, []);
    return (React.createElement("div", { id: props.id, className: cx(props.className, { disabled: props.disabled }) },
        React.createElement(IconButton, { "aria-controls": menuId, "aria-haspopup": "true", className: cx(classes.button, { [classes.active]: !!anchorEl }, props.iconButtonClassName), disabled: props.disabled, id: ix(props.id, 'button'), onClick: handleButtonClick, size: "large" }, props.buttonIcon || React.createElement(MoreVertIcon, null)),
        React.createElement(MUIMenu, { classes: {
                paper: classes.menuPaper,
                list: classes.menuList,
            }, id: menuId, anchorEl: anchorEl, anchorOrigin: {
                vertical: 'bottom',
                horizontal: horizontalPopoverOffset,
            }, transformOrigin: {
                vertical: 'top',
                horizontal: horizontalPopoverOffset,
            }, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, props.items &&
            props.items.map((menuItem) => (React.createElement(MUIMenuItem, { key: menuItem.id, disabled: menuItem.disabled, id: getMenuItemId(menuItem), onClick: handleItemClick(menuItem) },
                menuItem.icon && React.createElement(MUIListItemIcon, null, menuItem.icon),
                typeof menuItem.label === 'string' ? (React.createElement(Typography, { variant: "body2" }, menuItem.label)) : (menuItem.label)))))));
}
//# sourceMappingURL=Menu.js.map